// White-perspective centipawns -> White's win chance 0–100, Lichess' logistic mapping (0cp -> 50%,
// +1000cp -> ~97%). Twin of chess/Evaluation/WinChance.cs: the same swing classifies moves on the
// server, so they must agree to the point. Change one, change the other.
//
// `mateIn` is signed from White's side (+3 = White mates in 3), handled separately because clamped
// centipawns saturate at ~98%.
export function whiteWinPct(
  centipawns: number | null | undefined,
  mateIn?: number | null,
): number {
  if (mateIn != null) {
    // Distance 0 is checkmate on the board and must not fall through to the curve. The winner comes from
    // the White-normalised score (see MateScoreCp).
    if (mateIn !== 0) {
      return mateIn > 0 ? 100 : 0;
    }
    return (centipawns ?? 0) < 0 ? 0 : 100;
  }
  const cp = Math.max(-1000, Math.min(1000, centipawns ?? 0));
  const pct = 50 + 50 * (2 / (1 + Math.exp(-0.00368208 * cp)) - 1);
  return Math.round(pct);
}

// A forced mate on a readout: "M3" for the mover, "-M3" when being mated. Null otherwise.
export function mateLabel(mateIn: number | null | undefined): string | null {
  if (mateIn == null || mateIn === 0) {
    return null;
  }
  return mateIn > 0 ? `M${mateIn}` : `-M${Math.abs(mateIn)}`;
}
